import { z } from "zod";

import { language } from "@rootreeweb/ns-helper";

import type { FormDefinition } from "../types.js";
import { consentTextEN, consentTime, newslettersEN } from "./shared.js";

const schema = z.object({
	Email: z.string().email(),
	"First Name": z.string(),
	Company: z.string(),
	Language: language,
	Preferences: newslettersEN,
	"Consent Text": consentTextEN,
	"Consent Time": consentTime,
});

const newsletterSignup: FormDefinition<typeof schema.shape> = {
	signature: "6abeb2959a0442ad24b0d46c9b44a51a2d7308b3387e7110b3a04d594dff2250",
	formID: "newsletter-signup-en",
	schema,
	formOptions: {
		redirect: "https://rootree.ca/newsletter/thank-you/",
		submitButtonLabel: "Subscribe",
	},
};
export default newsletterSignup;
